// extracted by mini-css-extract-plugin
export default {"banner":"o-","mobileImage":"p-","deskimg":"q-","desktopImage":"r-","wrapper":"s-","text":"t-","text_wrapper":"u-","breadContain":"v-","systemWrapper":"w-","system":"x-"};
    if(module.hot) {
      // 1711717535204
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  